import { CachedService, PaymentInfo } from './types';

class AdminService extends CachedService<{}> {
  GetPayments = async () => this.Get<PaymentInfo>('/admin/payments');
}

export const instance = new AdminService('ck_admSrv');

export default instance;
